import type { FilterValue } from '../../../shared/filters/collectionFilterQuery'

/** Reports whether a filter has a selected scalar value or non-empty array. */
export function hasFilterValue<T>(
	value: FilterValue<T> | null | undefined,
): boolean {
	return Array.isArray(value) ? value.length > 0 : value != null
}

/** Cache keys preserve the distinction between scalars and arrays. */
export function filterValueKey(value: unknown): string {
	return JSON.stringify(
		Array.isArray(value) ? value.map(String).sort() : (value ?? null),
	)
}

export function normalizeDefaultFolderIds(
	value: number | number[] | null | undefined,
): number | number[] | null {
	const values = (Array.isArray(value) ? value : [value]).filter(
		(item): item is number =>
			typeof item === 'number' && Number.isFinite(item) && item > 0,
	)
	if (values.length === 0) return null
	return values.length === 1 ? values[0] : [...new Set(values)]
}

export function normalizeDefaultStrings(
	value: string | string[] | null | undefined,
): string | string[] | undefined {
	const values = (Array.isArray(value) ? value : [value]).filter(
		(item): item is string => typeof item === 'string' && item.length > 0,
	)
	if (values.length === 0) return undefined
	return values.length === 1 ? values[0] : [...new Set(values)]
}

export function cloneFilterValue<
	T extends FilterValue<string | number> | null | undefined,
>(value: T): T {
	return (Array.isArray(value) ? [...value] : value) as T
}
